import Thunk, { ThunkConfig } from 'src/thunks/index';
import { Data } from 'src/interfaces/general';
import classTopicContentActions from 'src/store/model/class_topic_content';
import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  selectProgress,
  selectStepContentList,
} from 'src/store/model/class_topic';
import { updateClassUser } from 'src/thunks/classes';
import { fetchClassUserStatus } from 'src/thunks/class_user_status';

const class_topic_content_competition = new Thunk();

export const markCompleted = class_topic_content_competition.create<
  Data<Model.ClassTopicContentCompetition>,
  Partial<Model.ClassTopicContentCompetition>
>('class_topic_content_completions/complete', {
  onSuccess({ dispatch, data }) {
    dispatch(classTopicContentActions.updateCompetition(data.data));
  },
});

export const updateProgress = createAsyncThunk<
  void,
  {
    class_id?: string;
    pathName: string;
    class_user?: Partial<Model.ClassUser>;
    isCompleted?: Boolean;
  },
  ThunkConfig
>(
  'update_progress',
  async (
    { class_id, isCompleted = true, pathName, class_user },
    { dispatch, getState },
  ) => {
    const { progress } = selectProgress(getState(), class_id!);
    const { stepSaveToServer, current } = selectStepContentList(
      getState(),
      class_id,
      pathName,
    );
    const classUser =
      class_user ||
      Object.values(getState().model.class_user.entities).find(
        (c) =>
          c?.class_id === class_id && c?.user_id === getState().ui.app.me?.id,
      );

    await dispatch(fetchClassUserStatus({}));
    await dispatch(
      updateClassUser({
        ...classUser,
        class_progress: {
          current_progress: isCompleted ? stepSaveToServer : current,
          percentage: progress,
        },
      }),
    );
  },
);
